import { PotionTicketBook, PotionPromoType } from '@/components/game/implementations/uk/potion/_domain/models/ticket-book';

class PotionRecipeItem {
    public symbol: string;
    public quantity: number;
    public promoType?: PotionPromoType;
}

type RecipeFunction = (promoType?: PotionPromoType) => PotionRecipeItem[];

const ticketBookRecipeMap: { [key: string]: RecipeFunction } = {
  [PotionTicketBook.Youth]: getYouthRecipe,
  [PotionTicketBook.Love]: getLoveRecipe,
  [PotionTicketBook.Wisdom]: getWisdomRecipie
};

function getRecipeForTicketBookId(ticketBookId: PotionTicketBook, promoType?: PotionPromoType): PotionRecipeItem[] {
  const recipeFunc = ticketBookRecipeMap[ticketBookId];
  return recipeFunc ? recipeFunc(promoType) : [];
}

function getYouthRecipe(promoType?: PotionPromoType): PotionRecipeItem[] {
  const isPumpkinPromo = (promoType === PotionPromoType.Pumpkin1);
  return [
    { symbol: isPumpkinPromo ? 'pumpkin' : 'mandrake', quantity: 2 },
    { symbol: 'honey', quantity: 2 }
  ];
}

function getLoveRecipe(promoType?: PotionPromoType): PotionRecipeItem[] {
  const isPumpkinPromo = (promoType === PotionPromoType.Pumpkin2);
  return [
    { symbol: isPumpkinPromo ? 'pumpkin' : 'dragon', quantity: 2 },
    { symbol: 'rose', quantity: 2 },
    { symbol: 'mushroom', quantity: 2 }
  ];
}

function getWisdomRecipie(promoType?: PotionPromoType): PotionRecipeItem[] {
  const isPumpkinPromo = (promoType === PotionPromoType.Pumpkin3);
  if (promoType === PotionPromoType.Luck) {
    return [
      { symbol: 'clover', quantity: 1, promoType },
      { symbol: 'heather', quantity: 3, promoType },
      { symbol: 'ladybird', quantity: 4, promoType }
    ];
  }
  return [
    { symbol: isPumpkinPromo ? 'pumpkin' : 'snake', quantity: 1 },
    { symbol: 'beetle', quantity: 3 },
    { symbol: 'crystal', quantity: 4 }
  ];
}

export { PotionRecipeItem, getRecipeForTicketBookId };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/potion/_domain/models/potion-recipe.ts